import { serializable, alias, object, list, primitive } from "serializr";
import { IdNameModel } from "./branches.model";
import { InstituteTutorModel } from "./tutor.model";

export class LiveClassCreateModel {
  @serializable(alias("title", primitive()))
  title?: string;

  @serializable(alias("date", primitive()))
  date?: string;

  @serializable(alias("start_time", primitive()))
  startTime?: string;

  @serializable(alias("duration", primitive()))
  duration?: string;

  @serializable(alias("branch_id", primitive()))
  branchId?: number;

  @serializable(alias("subject_id", primitive()))
  subjectId?: number;

  @serializable(alias("class_room_id", primitive()))
  classRoomId?: number;

  @serializable(alias("section_ids", list(primitive())))
  sectionIds?: number[] = [];

  @serializable(alias("tutor_ids", list(primitive())))
  tutorIds?: number[] = [];

  @serializable(alias("student_ids", list(primitive())))
  studentIds?: number[] = [];
}

export class LiveClassRoomModel extends IdNameModel {
  @serializable(alias("branch_class_room_id", primitive()))
  branchClassRoomId?: number;
}

export class LiveClassTutorModel extends InstituteTutorModel {
  @serializable(alias("id", primitive()))
  id!: number;
}

export class LiveClassModel {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("title", primitive()))
  title?: string;

  @serializable(alias("created_tutor_id", primitive()))
  createdTutorId?: number;

  @serializable(alias("start_time", primitive()))
  startTime?: string;

  @serializable(alias("end_time", primitive()))
  endTime?: string;

  @serializable(alias("duration", primitive()))
  duration?: string;

  @serializable(alias("date", primitive()))
  date?: string;

  @serializable(alias("tutors", list(object(LiveClassTutorModel))))
  tutors?: LiveClassTutorModel[] = [];

  @serializable(alias("class_room", object(LiveClassRoomModel)))
  classRoom?: LiveClassRoomModel;

  @serializable(alias("subject", object(IdNameModel)))
  subject?: IdNameModel;

  @serializable(alias("sections", list(object(LiveClassRoomModel))))
  sections?: LiveClassRoomModel[] = [];

  @serializable(alias("branch", object(IdNameModel)))
  branch?: IdNameModel;

  @serializable(alias("is_live_now", primitive()))
  isLiveNow?: boolean;

  @serializable(alias("student_ids", list(primitive())))
  studentIds?: number[] = [];
}

export class InstituteTutorsMetaModel {
  @serializable(alias("id", primitive()))
  value?: string;
  @serializable(alias("full_name", primitive()))
  label?: string;
}

export class JoinLiveClassModel {
  @serializable(alias('liveClassId', primitive()))
	liveClassId?: number;
  @serializable(alias('userType', primitive()))
	userType?: string;
  @serializable(alias('userId', primitive()))
	userId?: number;
  @serializable(alias('requestFrom', primitive()))
	requestFrom?: string;
}
